import {IEvent} from '@app-types/websocket/event.types';
import {ITodo, TODO_TYPE} from '@app-types/websocket/todo.types';

export const getCalendarTodos = (events: IEvent[], now: number): IEvent[] => {
  const today = new Date(now);
  // Use local calendar days so both boundary dates are included, also across DST.
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 3).getTime();
  const until = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 8).getTime();
  return events
    .filter(event => event.checkmark === true && event.startTime >= from && event.startTime < until)
    .sort((a, b) => a.startTime - b.startTime || a.id - b.id);
};

export const getCalendarTodoCount = (events: IEvent[], accountId: number, now: number): number =>
  getCalendarTodos(events, now)
    .filter(event => !event.completedBy && event.tagged && event.tagged.includes(accountId)).length;

// Adapt only the row presentation. Reads, edits and completion use the calendar event.
export const calendarEventAsTodo = (event: IEvent): ITodo => ({
  id: event.id,
  title: event.title,
  description: event.description,
  creator: event.creator,
  type: TODO_TYPE.NORMAL,
  assigned: event.tagged,
  visible: event.visible || [],
  seen: event.seen,
  dueDate: event.startTime,
  completedBy: event.completedBy,
});



// WEBPACK FOOTER //
// ./src/components/todo/calendarTodoItems.ts